import type * as SettingType from "./type/setting"
import { request } from "@/utils/service"

const PREFIX = "teashop_merchant/"

/**
 * 获取版本信息
 */
export function getVersion() {
  return request<IApiResponseData<string>>({
    url: `${PREFIX}/version`,
    method: "GET",
  })
}

/**
 * 获取配置
 * @param configKey - 配置键，如 sms_purchase_address: 短信购买地址
 * @returns 配置值
 */
export function getConfig(configKey: string) {
  return request<IApiResponseData<string>>({
    url: `${PREFIX}/business/config/get/${configKey}`,
    method: "GET",
  })
}

/**
 * 获取短信类型列表
 * @param start - 开始日期（可选）
 * @param end - 结束日期（可选）
 * @returns 短信类型列表
 */
export function getMessageTypeList(start?: string, end?: string) {
  return request<IApiResponseData<SettingType.SMSTypeInfoDTO[]>>({
    url: `${PREFIX}sms/type/list`,
    method: "GET",
    params: {
      start,
      end,
    },
  })
}

/**
 * 切换短信通知状态
 * @param typeId - 类型id
 * @param status - 状态；会员消费支持 0 关闭 / 1 余额变动 / 2 积分变动 / 3 每次消费，其他类型仅支持 0/1
 * @returns 切换是否成功
 */
export function switchMessageStatus(typeId: number, status: SettingType.SMSNotificationStatus) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}sms/status/switch`,
    method: "POST",
    params: {
      typeId,
      status,
    },
  })
}

/**
 * 获取当前商户消息使用情况
 * @returns 商户消息使用情况统计
 */
export function getMessageUsage() {
  return request<IApiResponseData<SettingType.SMSUsageStatTuple>>({
    url: `${PREFIX}sms/usage`,
    method: "GET",
  })
}

/**
 * 获取当前短信配置情况
 * @returns 店铺简称
 */
export function getSMSConfig() {
  return request<IApiResponseData<SettingType.SMSConfigTuple>>({
    url: `${PREFIX}sms/config/current`,
    method: "GET",
  })
}

/**
 * 获取短信店铺简称
 * @returns 店铺简称
 */
export function getSMSShortShopName() {
  return request<IApiResponseData<string>>({
    url: `${PREFIX}sms/short_shop_name`,
    method: "GET",
  })
}

/**
 * 更新短信门店简称
 * @param shortShopName - 店铺简称
 * @returns 更新是否成功
 */
export function updateSMSShortShopName(shortShopName: string) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}sms/config/update`,
    method: "PUT",
    params: {
      shortShopName,
    },
  })
}

/**
 * 配置短信通知服务
 * @param shopId - 店铺id
 * @param smsQuota - 短信配额
 * @returns 配置是否成功
 */
export function configureShortMessageService(shopId: number, smsQuota: number) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}sms/config/enable`,
    method: "POST",
    params: {
      shopId,
      smsQuota,
    },
  })
}

/**
 * 禁用短信通知服务
 * @param shopId - 店铺id
 * @returns 禁用是否成功
 */
export function disableShortMessageService(shopId: number) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}sms/config/disable`,
    method: "POST",
    params: {
      shopId,
    },
  })
}
